import * as React from "react"
import {useEffect} from "react"
import {useLocation} from "react-router-dom";
import {Box, Typography} from "@mui/material";
import {IconSeeker} from "@ui-seeker/core";

import {AppExtendedNavDrawer, AppMiniNavDrawer, AppMobileNavDrawer, AppNav} from "../../../@componets";
import {appName, openMenu} from "../../../@signals";
import {useApp} from "../../../@hooks";
import { dsColorNew } from "@palette";
import MaximalLayoutNavToggleButton from "./ToggleButton";
import {MaximalLayoutNavSectionMini, MaximalLayoutNavSectionVertical} from "./NavSection";
import { alpha } from "@mui/material/styles"


export default function MaximalLayoutNav({ routes=[], sx={} }) {
    const { pathname } = useLocation();
    const { isMini, isDesktop } = useApp()

    const DrawerComponent = isMini ?
        AppMiniNavDrawer
        : isDesktop ? AppExtendedNavDrawer : AppMobileNavDrawer

    useEffect(() => {
        if (openMenu.value) openMenu.value = false
    }, [pathname])

    const drawerStyles = {
        ...sx?.PaperProps?.sx,
        top: 0,
        height: '100%',
        zIndex: 1100
    }

    return <AppNav>
        { !!isDesktop && <MaximalLayoutNavToggleButton /> }

        <DrawerComponent
            scrollbarProps={{ sx: sx?.scrollbar }}
            PaperProps={{
                ...sx?.PaperProps,
                sx: drawerStyles
            }}
        >
            {/* Brand header */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMini ? 'center' : 'flex-start',
                gap: '16px',
                height: '72px',
                px: 2.5,
                flexShrink: 0,
                borderBottom: `1px solid ${alpha(dsColorNew.white, 0.08)}`
            }}>
                <Box sx={{
                    width: 36, height: 36, borderRadius: '8px',
                    backgroundColor: dsColorNew.appBlue,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    flexShrink: 0
                }}>
                    <IconSeeker icon="car" sx={{ fontSize: 18, color: dsColorNew.white }} />
                </Box>
                { !isMini && <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: dsColorNew.white, fontWeight: 700, fontSize: 15, lineHeight: 1.2, whiteSpace: 'nowrap' }}>
                        {appName}
                    </Typography>
                </Box> }
            </Box>

            { !!isMini && <MaximalLayoutNavSectionMini routes={routes} sx={sx?.navMini} /> }
            { !isMini && <MaximalLayoutNavSectionVertical routes={routes} sx={sx?.navExtend} /> }
        </DrawerComponent>
    </AppNav>
}
